module.exports = __webpack_public_path__ + "img/icon_buzz_lines_right_white.40c9a692.svg";